import { useCallback, useState } from 'react';
import CarrierService from '../../services/settings/ppoints/CarrierService';

export const useCarrierService = () => {
    const [isLoading, setIsLoading] = useState(false);

    const createCarrierService = useCallback(() => {
        setIsLoading(true);
        return CarrierService.createService().finally(() => setIsLoading(false));
    }, []);

    const deleteCarrierService = useCallback(() => {
        setIsLoading(true);
        return CarrierService.deleteService().finally(() => setIsLoading(false));
    }, []);

    return {
        createCarrierService,
        deleteCarrierService,
        isLoading,
    };
};
